"use client";

import React, { useEffect, useState } from "react";
import "./register.css";
import { fetchAPI } from "../utils/api";
import Alert from "@mui/material/Alert";

function RegisterForm() {
  const [memberNumber, setMemberNumber] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [pasportNumber, setPassportNumber] = useState("");
  const [hasNoIdNumber, setHasNoIdNumber] = useState(false);
  const [email, setEmail] = useState("");
  const [cellphoneNumber, setCellphoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const step1Validation = () => {
    if (memberNumber.trim() === "") {
      alert("Please enter a member number.");
    } else if (idNumber.trim() === "" && !hasNoIdNumber) {
      alert("Please enter an ID Number.");
    } else if (email.trim() === "") {
      alert("Please enter an email address.");
    } else if (password.trim() === "") {
      alert("Please enter a password.");
    } else if (confirmPassword.trim() === "") {
      alert("Please confirm your password.");
    } else if (password !== confirmPassword) {
      alert("Passwords do not match.");
    } else {
      return true;
    }
    return false;
  };

  useEffect(() => {
    // smooth scroll to id join-now-form
    const joinNowForm = document.getElementById(`join-now-form`);
    if (joinNowForm) {
      joinNowForm.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  // Handle form submission for Step 1
  const handleSubmitStep1 = async (e) => {
    e.preventDefault();

    if (!step1Validation()) return;

    try {
      setIsLoading(true);
      await fetchAPI("/register", "POST", {
        Email: email,
        Password: password,
        Company: 7,
        IdNumber: idNumber,
        Passport: pasportNumber,
        MemberNumber: memberNumber,
        Cellnumber: cellphoneNumber,
        ActivationCode: "",
      }).then((res) => {
        setIsLoading(false);
        if (res?.Registered) {
          setStatus("success");
          setMessage(
            "Registration successful. Please check your email for activation link."
          );
        } else {
          setStatus("error");
          setMessage(res.Message);
        }

        // reset form and status after 3 seconds
        setTimeout(() => {
          setStatus(null);
          setMessage("");
          setMemberNumber("");
          setIdNumber("");
          setPassportNumber("");
          setHasNoIdNumber(false);
          setEmail("");
          setCellphoneNumber("");
          setPassword("");
          setConfirmPassword("");
        }, 3000);
      });
    } catch (error) {
      setIsLoading(false);
      setStatus("error");
      setMessage("Whoops!!! Something went wrong, try again");

      // reset status after 3 seconds
      setTimeout(() => {
        setStatus(null);
        setMessage("");
      }, 3000);
    }
  };

  return (
    <section className="section-bg" id="join-now-form">
      {status && <Alert severity={status}>{message}</Alert>}
      <div className="join-cont">
        <form onSubmit={handleSubmitStep1}>
          <section>
            <div className="form-item  mfn fi-40">
              <label>Member Number:</label>
              <input
                type="text"
                value={memberNumber}
                onChange={(e) => setMemberNumber(e.target.value)}
              />
            </div>
            <div className="form-item mln fi-40">
              <label>
                {hasNoIdNumber
                  ? "Passport or other identification number"
                  : "ID Number"}
                :
              </label>
              <input
                type="text"
                value={hasNoIdNumber ? pasportNumber : idNumber}
                onChange={(e) =>
                  hasNoIdNumber
                    ? setPassportNumber(e.target.value)
                    : setIdNumber(e.target.value)
                }
              />
            </div>
          </section>
          <section>
            <div className="form-item fi-40"></div>
            <div className="form-item mln fi-40 checkbox">
              <input
                type="checkbox"
                value={hasNoIdNumber}
                onChange={(e) => setHasNoIdNumber(e.target.checked)}
                checked={hasNoIdNumber}
              />
              <label>I don't have a South African ID number.</label>
            </div>
          </section>
          <section>
            <div className="form-item fi-40">
              <label>Email Address:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-item fi-40">
              <label>Cell Number:</label>
              <input
                type="tel"
                value={cellphoneNumber}
                onChange={(e) => setCellphoneNumber(e.target.value)}
              />
            </div>
          </section>
          <section className="title">
            <label>
              And you'll need a password to login to the website in future.
            </label>
          </section>

          <section>
            <div className="form-item fi-40">
              <label>Password:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="form-item fi-40">
              <label>Re-type Password:</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </section>
          <div className="btn-cont mobile-btn-cont">
            <button
              className={`btn mobile-btn-join ${isLoading ? "disabled" : ""}`}
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "PROCESSING..." : "REGISTER"}
            </button>
            <button
              className={`btn mobile-btn-join ${isLoading ? "disabled" : ""}`}
              type="button"
              disabled={isLoading}
            >
              CANCEL
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default RegisterForm;
